// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__16nLe","actionsCol":"EnrolledClinics_actionsCol__1yk-r"};